import { API_ACCOUNT_DETAIL_TRANSFER_BASIC } from 'api/endpoints';
import { FormStore } from '../../formStore';
import { RootStore } from '../../rootStore';
import { FormikHelpers } from 'formik';
import { TransferData } from './model';
import { AccountDetailStore } from '../accountDetailStore';

export class TransferStore extends FormStore<TransferData> {
  accountDetailStore: AccountDetailStore;

  constructor(rootStore: RootStore, accountDetailStore: AccountDetailStore, accountId: string) {
    super(rootStore);
    this.rootStore = rootStore;
    this.accountDetailStore = accountDetailStore;
    this.accountId = accountId;
  }

  fetchTransferData = async () => {
    this.rootStore.stores.uiStore.setLoading(true);
    await this.fetchData(API_ACCOUNT_DETAIL_TRANSFER_BASIC(this.accountId));
    this.rootStore.stores.uiStore.setLoading(false);
  };

  handleNext = async (
    values: TransferData,
    formikHelpers: FormikHelpers<TransferData>,
  ) => {
    const ok = await this.submitData(API_ACCOUNT_DETAIL_TRANSFER_BASIC(this.accountId), values, {
      singleValueResponse: true,
      formikHelpers: formikHelpers,
      validationPrefixDepth: 2
    });

    if (ok) {
      this.accountDetailStore.goFwd()
    }
  };
}
